var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getInfoFromStorage)?_c('div',{staticClass:"album-header"},[_c('h2',{staticClass:"album-name"},[_vm._v(_vm._s(_vm.getInfoFromStorage.name))]),_c('p',{staticClass:"album-count"},[_vm._v("("+_vm._s(_vm.getInfoFromStorage.count)+" photos)")]),_c('p',{staticClass:"album-description"},[_vm._v(_vm._s(_vm.getInfoFromStorage.description))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }